module.exports = __webpack_public_path__ + "img/未标题-8.13d0d025.jpg";